import React from 'react'
import styled from 'styled-components'
import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { SPACING } from '../../design/spacing/spacing.constants'
import { COLOR } from '../../design/color/color.constants'
import { FONT_REGULAR, FONT_SIZE } from '../../design/typography/typography.constants'
import CrossIcon from './assets/alert-cross.svg'

const StyledCrossIcon = styled(CrossIcon)`
  cursor: pointer;
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
`

const CloseButton = ({ closeToast }) => (
  <IconContainer>
    <StyledCrossIcon onClick={closeToast} />
  </IconContainer>
)

const WrappedToastContainer = ({ className, ...rest }) => (
  <div className={className}>
    <ToastContainer transition={Slide} {...rest} />
  </div>
)

const StyledToastContainer = styled(WrappedToastContainer).attrs(() => {
  // custom props
})`
  .Toastify__toast-container {
    width: initial;
    top: 86px;
  }
  .Toastify__toast {
    width: 380px;
    min-height: 48px;
    border-radius: 4px;
    background-color: #E5F3F8;
    border: 1px solid ${COLOR.BLUE_MEDIUM};
    color: black;
    padding-left: ${SPACING.S};
    padding-right: ${SPACING.S};
    cursor: default;

    ${FONT_REGULAR};
    font-size: ${FONT_SIZE.MEDIUM};
  }

  .Toastify__toast--error {
    background-color: ${COLOR.RED_LIGHT};
    border: 1px solid ${COLOR.RED_MEDIUM};
  }
  .Toastify__toast--warning {
    background-color: #FFF6BF;
    border: 1px solid ${COLOR.YELLOW_MEDIUM};
  }
  .Toastify__toast--success {
    background-color: #E5F6F7;
    border: 1px solid ${COLOR.TEAL_MEDIUM};
  }
`

export { StyledToastContainer, CloseButton }
